<template>
  <div>
    <roles v-if="view == 1"></roles>
    <div v-else>
      <h5 class="mb-3">Información básica del rol</h5>
      <modalRol action="update"></modalRol>
      <hr />
      <permissions type="admin"></permissions>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ModalRol from './modalRol.vue';
import Permissions from "./permissions.vue";
import Roles from './roles.vue';

export default {
  name: "index",
  data() {
    return {};
  },
  components: {
    Permissions,
    Roles,
    ModalRol
  },
  computed: {
    ...mapState("rolesPermissions", ["view"]),
  },
};
</script>